<script>
  import {stringify} from 'query-string';
  import {getContext, onMount} from 'svelte';
  import {fly} from 'svelte/transition';
  import {stores} from '@sapper/app';
  import {mc} from '@/core';
  import {LINKS} from '@/const/link';
  import {PATHS} from '@/const/paths';
  import {IMAGES} from '@/const/images';
  import {langUtil} from '@/helper/lang';
  import {accountApi} from '@/api/account';
  import {isLogin$, userInfo$} from '@/store/user';
  import {lang$, fixLink$} from '@/store/lang';
  import {sd} from '@/da';
  import {userStatus$} from '@/streams/auth';
  import {languages$} from '@/streams/languages';
  import {CONVERT_LANG_MAP, LANG_MAP} from '@/map';
  import {isSupportMarginTrading$} from '@/streams/margin-trade';
  import {fiatABTest$} from '@/modules/fiat/streams';
  import Select from '@/widgets/Select.svelte';
  import SocialMedia from './components/SocialMedia.svelte';
  import {GetFooterLinks, aaa} from '@/modules/footer/constants';
  import lang from './Footer.lang';
  import {envUtil} from '@/helper';

  export let noShowBanner = false;

  const LG = getContext('LG');
  const {page} = stores();

  let showBanner = true;
  let VIPProgramPageLink = '';

  let visibles = [];

  $: language = $lang$;
  $: footerLinks = GetFooterLinks($lang$, $isLogin$, $isSupportMarginTrading$, $fiatABTest$, VIPProgramPageLink, envUtil.isMobile);
  $: footerOrder = envUtil.isMobile
    ? Array(footerLinks.length)
        .fill()
        .map((_, index) => index)
    : [...new Set(footerLinks.map((i) => i.order))];

  onMount(() => {
    const {pathname} = langUtil.parsePathname($page.path);
    showBanner = pathname !== PATHS.ABOUT_AMBASSADOR_KEVIN_DE_BRUYNE.pathname;
    getVIPProgramPageLink();
    visibles = envUtil.isMobile ? footerOrder.map((_, index) => index === 0) : footerOrder.map(() => true);
  });

  function getVIPProgramPageLink() {
    const target = location.origin + $fixLink$(PATHS.VIP_PROGRAM.pathname);
    VIPProgramPageLink = target + '?' + stringify({target, action: 'Target'});
  }

  function handleClickChange(e) {
    const val = e.detail.value;
    const lang = LANG_MAP[val] || val;
    if ($userStatus$ === 'Login') {
      const params = {
        lang,
      };
      updateProfile(params);
    } else {
      lang$.set(CONVERT_LANG_MAP[lang] || lang);
    }
  }

  async function updateProfile(params) {
    const {data, error} = await accountApi.updateProfile(params);
    if (data) {
      userInfo$.next(data);
      const {lang} = params;
      if (lang) {
        lang$.set(CONVERT_LANG_MAP[lang] || lang);
      }
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
  }

  function handleLinkBar(order) {
    if (!envUtil.isMobile) {
      return;
    }
    const status = visibles[order];
    visibles = visibles.map((_) => false);
    visibles[order] = !status;
  }

  function rewardClick () {
    sd.track('web_click', {$screen_name: 'home', $element_content: 'footer_services_rewards_hub'});
  }

  function clickHandler(item) {
    if (item.gal === 'welcome_bonus') {
      rewardClick()
    }
  }
</script>

<style>
  .wrap {
    background: #090a0a;
  }
  .main {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 80px 0 40px;
    width: 1200px;
  }
  .logo {
    margin-right: 80px;
    box-sizing: border-box;
    width: 166px;
  }
  .box ul {
    margin-top: 12px;
  }
  .box ul li + li {
    margin-top: 8px;
  }
  .box ul li a {
    display: inline-block;
    width: 100%;
  }
  .ga {
    min-width: 142px;
    color: #b0b2b8;
  }
  .ga:hover {
    color: #fff;
    opacity: 1;
  }
  .select :global(.white.wrap) {
    border: none;
    padding: 0;
    height: 28px !important;
    line-height: 28px !important;
  }
  .select :global(.white.wrap .cb) {
    line-height: 28px !important;
  }
  .select :global(.white.wrap i) {
    margin-left: 4px;
    color: #fff;
  }
  .select :global(.white.wrap .dropdown) {
    left: -28px;
    border-radius: 4px;
    padding: 6px 0;
    width: 120px;
    background: #202429;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }
  .select :global(.white.wrap .dropdown li) {
    height: 28px !important;
    line-height: 28px !important;
  }
  .select :global(.white.wrap .dropdown li:hover) {
    background: #3c4047;
  }
  .drop-arrow {
    transform: rotate(0deg);
    -moz-transform: rotate(0deg); /* Firefox */
    -webkit-transform: rotate(0deg);
    transition: all 0.2s ease-in-out;
  }
  .animation {
    transform: rotate(180deg);
    -moz-transform: rotate(180deg); /* Firefox */
    -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
    transition: all 0.2s ease-in-out;
  }
  .c-title {
    color: #f2f4fb;
  }
  .copyright {
    margin: 0 auto;
    border-top: 1px solid #1f2124;
    padding: 32px 0;
    width: 1200px;
    color: #b0b2b8;
  }
  .gap-32 {
    gap: 32px;
  }
  @media screen and (max-width: 640px) {
    .wrap {
      padding: 40px 0;
    }
    .main {
      flex-direction: column;
      padding: 0 16px 40px 16px;
      width: 100%;
    }
    .logo {
      margin-right: 0;
    }
    .box {
      margin-top: 0;
    }
    .c-title {
      height: 48px;
      line-height: 48px;
      font-size: 14px;
    }
    ul {
      display: block;
      margin-top: 0 !important;
    }
    li {
      margin-top: 0 !important;
      height: 48px;
      line-height: 48px;
      font-size: 12px;
    }
    .copyright {
      box-sizing: border-box;
      padding: 12px 16px;
      width: 100%;
      font-size: 12px;
    }
    .footer-links {
      margin-top: 32px;
    }
    .select {
      display: inline-flex;
      margin-top: 12px;
      border: 1px solid #454952;
      border-radius: 8px;
      padding: 4px 12px;
    }
    .select img {
      width: 16px;
      height: 16px;
    }
    .select :global(.white.wrap) {
      padding: 0;
    }
    .select :global(.white.wrap .cb) {
      font-size: 12px;
    }
  }
</style>

<footer class="wrap pr">
  <div class="main df">
    <div class="logo">
      <div>
        <img width="118" data-src={IMAGES.LOGO_LIGHT} src={IMAGES.LOGO_LIGHT} alt="Logo" />
      </div>
      <div class="dn mt12 f14 lh18 tc T4  xs:dn">{LG(lang.PhemexProfessional)}</div>
      <div class="mt32 xs:dn">
        <SocialMedia />
      </div>
      <div class="df aic select mt32">
        <img width="24px" height="24px" src="https://img.phemex.com/v1/a3504b73-da04-416b-9771-d6a662b062a4/language.svg" alt="lang icon" />
        <Select type="border" white bind:value={language} options={$languages$} on:change={handleClickChange}>
          <span slot="selectArrow" let:className>
            <i class="iconfont drop-arrow dib ml4 f12 {className}">&#xe756;</i>
          </span>
        </Select>
      </div>
    </div>
    <div class="f1 df fww TW footer-links xs:db">
      {#each footerOrder as order}
        <div class="df fdc gap-32 f1">
          {#each footerLinks as item}
            {#if item.order === order}
              <div class="df fdc box box-{item.order}">
                <div class="f16 fw3 TW c-title df jcsb" on:click={handleLinkBar.bind(null, order)}>
                  <span>{LG(item.title)}</span>
                  {#if envUtil.isMobile}
                    <i class="iconfont drop-arrow dib ml4 f12 fw2" class:animation={visibles[order]}>&#xe756;</i>
                  {/if}
                </div>
                {#if visibles[order]}
                  <ul transition:fly={{duration: 160}}>
                    {#each item.children as child}
                      <li on:click={clickHandler.bind(null, child)}>
                        <a
                          class="ga"
                          data-gac="footer.link"
                          data-gaa="link_click"
                          data-gal={child.gal}
                          href={child.linkTag || child.belong === 'PATHS' ? $fixLink$(child.link, child.linkTag) : child.link}
                          target={child.target || '_self'}>{LG(child.label)}</a
                        >
                      </li>
                    {/each}
                  </ul>
                {/if}
              </div>
            {/if}
          {/each}
        </div>
      {/each}
    </div>
    <div class="mt32 dn xs:db">
      <SocialMedia />
    </div>
  </div>
  <div class="f14 fw1 copyright">© 2018-{new Date().getFullYear()} {LG(lang.Copyright)}</div>
</footer>
